import React, { Component } from "react";
import PageContext, { getPageContext, updatePageContextAsync } from "../../components/Common/PageContext";
import { Backdrop, Grid2 as Grid } from "@mui/material";
import { withStyles } from "@mui/styles";
import { LoadingDialog } from "../../components/Loading/LoadingDialog";
import { InvoiceHeaderDetails } from "../../components/Invoice/InvoiceHeaderDetails";
import { MemorizedInvoiceLineItemTable } from "../../components/Invoice/InvoiceLineItemTable";
import {
	getCreditRequest,
	postReceiveAsync,
	postReopenPurchaseOrderAsync,
	postSubmitReceiveAsync,
	fetchReceivePurchaseOrderDetails,
	upsertCreditRequest,
	postLineItemReceivedAsync,
	postReceiveComment,
} from "../../services/apiHelper";
import ScanEditWithSaveButton from "../../components/Scan/ScanEditWithSaveButton";
import SnackbarAlert from "../../components/Snackbar/SnackbarAlert";
import { setStateAsync } from "../../util/stateHelper";
import { saveEventHistoryToList } from "../../util/historyStorageHelper";
import qs from "qs";
import {
	createOrUpdateReceive,
	getScannedItemByProductId,
	isEditable,
	isFullyReceived,
	isReceivedDirectInHost,
	isThereAnyPoLineAbleToBeReopened,
	validateInvoiceNumberAsync,
	validateReceiveAsync,
	createReceiveLineItemFromInvoiceLineItem,
} from "../../util/receiveUtil";
import { updateInvoiceLineItems } from "../../util/lineItemUtil";
import { ReceiveHistory } from "../../components/History/ReceiveHistory";
import {
	blockEdiScanStatusList,
	canBeClearedStatusList,
	canBeFinalisedStatusList,
	receiveStatus,
} from "../../util/receiveStatus";
import { v4 as uuidv4 } from "uuid";
import ModalReceiveFinalise from "../../components/Modal/ModalReceiveFinalise";
import modalSize from "../../util/modalSizeEnum";
import alertTypeEnum from "../../util/alertTypeEnum";
import SpeedDialMenu from "../../components/SpeedDial/SpeedDialMenu";
import { speedDialAction } from "../../util/speedDialUtil";
import { snackBarAlerts, SnackbarAlertState } from "../../util/snackBarAlert";
import { reduceCustomerOrdersToFIFO } from "../../util/customerOrderUtil";
import { sortItemsByModifiedDesc, sortItemsByPriorityStockFlag } from "../../util/sortUtil";
import { modals } from "../../util/modalUtil";
import { Modal } from "../../components/Modal/Modal";
import { emptyCurrentScannedProduct, modalClosed } from "../../util/emptyObjectsUtil";
import ArrivalsCheckinDialog from "../../components/Arrivals/ArrivalsCheckinDialog";
import { purchaseOrderStatus } from "../../util/purchaseOrderStatus";
import { creditStatus } from "../../util/creditRequestMapping";
import { groupByPriorityStockFlag } from "../../util/priorityStockUtil";
import CommercialSelect from "../../components/Select/CommercialSelect";
import ModalAssignLocation from "../../components/Modal/ModalAssignLocation";
import { ModalCreditRequestFinalise } from "../../components/Modal/ModalCreditRequestFinalise";
import {
	editLocationBay,
	isInboundLocation,
	isLocation,
	mapLocationBaysFromReceiveLineItems,
	updateLocationBays,
} from "../../util/locationTypeUtil";
import { LocationBay } from "../../components/Common/LocationBay/LocationBay";
import CurrentLocationBayAlert from "../../components/CurrentLocationBayAlert";
import AlertModal from "../../components/AlertModal/AlertModal";
import { receiveType } from "../../util/receiveTypeMapping";
import { ModalWithActionButton, ModalAlertType } from "../../components/Modal/ModalWithActionButton";
import { isFeatureEnabledForLocationAndReceiveType } from "../../util/featureUtil";
import { PriorityStockDialog } from "../../components/PriorityStock/PriorityStockDialog";
import { ModalHistory } from "../../components/Modal/ModalHistory";
import { CommentModal } from "../../components/Modal/CommentModal";
import { getTimestampInLocalTime } from "../../util/dateUtil";
import { statusToLabel } from "../../util/statusMapping";

// Props interface for Receiving component
interface ReceivingProps {
	classes: any;
	history: {
		push: (path: string) => void;
		block: (callback: any) => void;
	};
	location: {
		search: string;
	};
	match?: any;
	graphProfile: {
		staffId: string;
		displayName: string;
	};
}

// Modal type that doesn't require onExitClick
interface ModalState {
	isOpen: boolean;
	paragraphs: string[];
	primaryButtonName: string;
	secondaryButtonName?: string;
	onPrimaryButtonClick?: () => void;
	onSecondaryButtonClick?: () => void;
	title: string;
	isInfo?: boolean;
}

// State interface for Receiving component
interface ReceivingState {
	creditRequest: any;
	preventReceiving: boolean;
	invoiceDate: string;
	receivedDate: string | Date | null;
	invoiceHeaderDetails: {
		invoiceId: string;
		invoiceNumber: string;
		invoiceDate: string;
		purchaseOrderNumber: string;
		purchaseOrderStatus: string;
		purchaseOrderNotes: string;
		storeId: string;
		storeName: string;
		supplierName: string;
		invoiceType: string;
		receiveStatus: string;
		failureReason?: string | null;
		totalPriceInc: number;
		totalFreightInc: number;
		totalQty: number;
		receiptAttemptCount?: number;
		asns: any[];
	};
	invoiceLineItems: any[];
	isHistoryVisible: boolean;
	isPrintVisible: boolean;
	isSaveButtonEnable: boolean;
	isShowLoadingDialog: boolean;
	isShowAlert: boolean;
	isSpeedDialOpen: boolean;
	isHardwareView: boolean;
	isExpandedHeader: boolean;
	isInventoryProcessed: boolean;
	isSkipPrint: boolean;
	isCreditRequestPageRequired: boolean;
	containsCustomerOrders: boolean;
	showAlert: boolean;
	alertMessage?: string;
	isClearReceiveModalOpen: boolean;
	isScanEditVisible: boolean;
	currentScannedProduct: {
		qty: number | null;
		productId: string;
	};
	prices: any[];
	products: any[];
	purchaseOrder: any;
	receive: any;
	validationResult: { isValid: boolean; reason?: string; reasons?: string[] };
	receiveFinalise: {
		isDisabled: boolean;
		buttonName: string;
		isModalOpen: boolean;
		isCreditRequestModalOpen: boolean;
		hasCredit: boolean;
		isCreditRequestClaimed: boolean;
		isFullyReceived: boolean;
		hasLabels?: boolean;
	};
	receiveId: string;
	clearExtraReceive: {
		isModalOpen: boolean;
		modalMessage: string;
		sku: string;
	};
	snackBarAlert: SnackbarAlertState;
	modalAlert: ModalState;
	allocatedCustomerOrders: any[];
	canPurchaseOrderBeReopened: boolean;
	modal: ModalState;
	arrivals: any[];
	poToCheckin: any[];
	canCheckinShipment: boolean;
	openArrivalsCheckinDialog: boolean;
	showSubmittingArrivalLoading: boolean;
	scannedArrivalConsignmentNumber: string | null;
	openPriorityStockDialog: boolean;
	purchaseOrderPriorityStock: { poNumber: string | null; priorityStock: any };
	flatPriorityStock: any[];
	inboundLocation: string | null;
	submitReceiveRequest: {
		receive: any;
		orders: any[];
		printerId: string | null;
		localTimestamp: string | null;
	};
	locationId: string;
	assignLocation: {
		sku: string;
		currentLocation: string;
		isModalOpen: boolean;
		scannedLocation: string;
		context: "manual" | "scanned";
	};
	locationBays: string[];
	isBlocking: boolean;
	showArrivalsCheckingDialogCloseConfirmation: boolean;
	enableProductLabelAutoPrint: boolean;
	enabledPriorityStock: boolean;
	alertModal: {
		isOpen: boolean;
		title: string;
		status: "success" | "info" | "warning" | "error";
		onClose?: () => void;
	};
	receiveType: string;
	notes: string;
	comments: any[];
	commentModal: {
		isOpen: boolean;
	};
	skuForHistory?: string;
	customerOrders?: any[];
	inventory?: any[];
	enableAssignIbLocation?: boolean;
	isDeliveredDateDisabled?: boolean;
}

const styles = (theme: any) => ({
	speedDial: {
		...theme.palette.custom.speedDial,
	},
	speedDialAction: {
		...theme.palette.custom.speedDialAction,
	},
	speedDialTooltipLabel: {
		...theme.palette.custom.speedDialTooltipLabel,
	},
	backDrop: {
		zIndex: 1000,
	},
	marginBottom: {
		marginBottom: 100,
	},
	finaliseGrid: {
		padding: "0 0 30px 0",
	},
});

const initialInvoiceHeaderDetailsObj = {
	invoiceId: "",
	invoiceNumber: "",
	invoiceDate: "",
	purchaseOrderNumber: "",
	purchaseOrderStatus: "",
	purchaseOrderNotes: "",
	storeId: "",
	storeName: "",
	supplierName: "",
	invoiceType: "",
	receiveStatus: "",
	totalPriceInc: 0,
	totalFreightInc: 0,
	totalQty: 0,
	receiptAttemptCount: 0,
	asns: [],
};

class Receiving extends Component<ReceivingProps, ReceivingState> {
	static contextType = PageContext;
	setStateAsync: (state: Partial<ReceivingState>) => Promise<void>;
	updatePageContextAsync: (context: any) => Promise<void>;
	getPageContext: () => any;
	private scanQueue: Promise<void> = Promise.resolve();

	constructor(props: ReceivingProps) {
		super(props);
		this.state = {
			creditRequest: null,
			preventReceiving: false,
			invoiceDate: "",
			receivedDate: null,
			invoiceHeaderDetails: initialInvoiceHeaderDetailsObj,
			invoiceLineItems: [],
			isHistoryVisible: false,
			isPrintVisible: false,
			isSaveButtonEnable: false,
			isShowLoadingDialog: true,
			isShowAlert: false,
			isSpeedDialOpen: false,
			isHardwareView: true,
			isExpandedHeader: true,
			isInventoryProcessed: false,
			isSkipPrint: false,
			isCreditRequestPageRequired: false,
			containsCustomerOrders: false,
			showAlert: false,
			isClearReceiveModalOpen: false,
			isScanEditVisible: true,
			currentScannedProduct: {
				qty: 0,
				productId: "",
			},
			prices: [],
			products: [],
			purchaseOrder: null,
			receive: null,
			validationResult: { isValid: true, reason: "" },
			receiveFinalise: {
				isDisabled: false,
				buttonName: "Finalise",
				isModalOpen: false,
				isCreditRequestModalOpen: false,
				hasCredit: false,
				isCreditRequestClaimed: false,
				isFullyReceived: false,
			},
			receiveId: uuidv4(),
			clearExtraReceive: {
				isModalOpen: false,
				modalMessage: "",
				sku: "",
			},
			snackBarAlert: snackBarAlerts.closed,
			modalAlert: modalClosed,
			allocatedCustomerOrders: [],
			canPurchaseOrderBeReopened: false,
			modal: modalClosed,
			arrivals: [],
			poToCheckin: [],
			canCheckinShipment: false,
			openArrivalsCheckinDialog: false,
			showSubmittingArrivalLoading: false,
			scannedArrivalConsignmentNumber: null,
			openPriorityStockDialog: false,
			purchaseOrderPriorityStock: { poNumber: null, priorityStock: {} },
			flatPriorityStock: [],
			inboundLocation: null,
			submitReceiveRequest: {
				receive: null,
				orders: [],
				printerId: null,
				localTimestamp: null,
			},
			locationId: "",
			/* Changing the location bay for receive line item(s) */
			assignLocation: {
				/* Set when changing the location bay for a specific sku */
				sku: "",
				/* The location bay currently assigned to the line item(s) */
				currentLocation: "",
				isModalOpen: false,
				/* The location bay being scanned by the user */
				scannedLocation: "",
				context: "manual",
			},
			locationBays: [],
			isBlocking: false,
			showArrivalsCheckingDialogCloseConfirmation: false,
			enableProductLabelAutoPrint: false,
			enabledPriorityStock: false,
			alertModal: {
				isOpen: false,
				title: "",
				status: "success",
				onClose: () => {},
			},
			receiveType: receiveType.edi,
			notes: "",
			comments: [],
			commentModal: {
				isOpen: false,
			},
		};
		this.setStateAsync = setStateAsync.bind(this);
		this.updatePageContextAsync = updatePageContextAsync.bind(this);
		this.getPageContext = getPageContext.bind(this);
	}

	async componentDidMount() {
		// Future state/TODO: Check if page context is null, then read the query string and call APIs to get data
		const {
			featureConfiguration: { inboundLocationAssignment, productLabelAutoPrint, priorityStock },
		} = this.getPageContext();

		let receiveDetails = null;
		const queryStringObject = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
		const { purchaseOrderNumber, invoiceNumber, id } = queryStringObject;
		try {
			const receiveDetailsResponse = await fetchReceivePurchaseOrderDetails(
				purchaseOrderNumber,
				invoiceNumber,
				id,
				true
			);
			const creditRequestInContext = this.getPageContext().receiveDetails?.CreditRequest;
			receiveDetails = {
				MatchedReceive: receiveDetailsResponse.data.matchedReceive,
				Invoice: receiveDetailsResponse.data.invoice,
				PurchaseOrder: receiveDetailsResponse.data.purchaseOrder,
				CreditRequest:
					receiveDetailsResponse.data.creditRequest ??
					(creditRequestInContext?.invoiceNumber === invoiceNumber ? creditRequestInContext : null),
				Arrivals: receiveDetailsResponse.data.arrivals,
				Products: receiveDetailsResponse.data.products,
				ProductPrices: receiveDetailsResponse.data.productPrices,
				CustomerOrders: receiveDetailsResponse.data.customerOrders,
				PriorityStock: receiveDetailsResponse.data.priorityStock,
				Comments: receiveDetailsResponse.data.comments || [],
				Asns: receiveDetailsResponse.data.advancedShippingNotices || [],
			};
		} catch (e) {
			//Todo: will handle error nicer, for now just console log
			console.log(e);
			this.props.history.push("/");
			return;
		}

		await this.updatePageContextAsync({ receiveDetails });

		// To decide whether to display Check in shipment on speed-dial or not
		const canCheckin = this.canCheckinShipment();
		const poToCheckin = [];
		// This is used by Arrival Checkin Dialog for validation of consignment number
		if (canCheckin && receiveDetails.Invoice) {
			poToCheckin.push({
				po: receiveDetails.Invoice?.purchaseOrderNumber,
				invoices: [receiveDetails.Invoice?.invoiceNumber],
			});
		}
		this.setStateAsync({ poToCheckin, canCheckinShipment: canCheckin });

		// check if already received in SK
		const isAlreadyReceived = isReceivedDirectInHost(undefined, receiveDetails.Invoice?.status);
		const isReceiveFinalisable = receiveDetails.MatchedReceive
			? canBeFinalisedStatusList.includes(receiveDetails.MatchedReceive.status)
			: true;

		// validate invoice number
		let invoiceNumberValidationResults = { isValid: true, reason: "" };
		if (receiveDetails.MatchedReceive && canBeFinalisedStatusList.includes(receiveDetails.MatchedReceive.status)) {
			invoiceNumberValidationResults = await validateInvoiceNumberAsync(
				receiveDetails.MatchedReceive?.invoiceNumber ?? receiveDetails.Invoice?.invoiceNumber,
				receiveDetails.PurchaseOrder.sourceId,
				receiveDetails.PurchaseOrder.vendorId,
				receiveDetails.MatchedReceive.receiveType,
				receiveDetails.MatchedReceive.id,
				[]
			);
		}

		const canPurchaseOrderBeReopened = isThereAnyPoLineAbleToBeReopened(
			(receiveDetails.PurchaseOrder?.lineItems ?? []).reduce(
				(lItems, li) => [
					...lItems,
					{
						status: li.status,
						orderedQuantity: li.quantity,
						originalQuantity: li.originalQuantity,
					},
				],
				[]
			)
		);

		const enabledPriorityStock = isFeatureEnabledForLocationAndReceiveType(
			receiveDetails.PurchaseOrder.shipToLocation.locationId,
			priorityStock,
			receiveDetails?.MatchedReceive?.receiveType ?? this.state.receiveType
		);

		const receiveComments =
			receiveDetails.MatchedReceive && Array.isArray(receiveDetails.MatchedReceive.comments)
				? receiveDetails.MatchedReceive.comments
				: receiveDetails.Comments || [];

		const purchaseOrderComment = {
			id: receiveDetails.PurchaseOrder.id ?? "",
			receiveId: receiveDetails.MatchedReceive?.id ?? "",
			createdTimestamp: getTimestampInLocalTime(receiveDetails.PurchaseOrder.dateCreated),
			createdByUserId: "",
			createdByUserName: "INTEGRATION JB API",
			text: receiveDetails.PurchaseOrder.description,
			sourceSystem: "Purchase Order",
		};

		const invoiceComments =
			receiveDetails.Invoice && Array.isArray(receiveDetails.Invoice.comments)
				? receiveDetails.Invoice.comments.map((c) => {
						return {
							id: c.id,
							receiveId: receiveDetails.MatchedReceive?.id ?? "",
							createdTimestamp: c.createdTimestamp,
							createdByUserId: c.createdByUserId,
							createdByUserName: c.createdByUserName,
							text: c.text,
							sourceSystem: "Invoice",
						};
					})
				: [];

		const concatenatedComments = receiveComments.concat([purchaseOrderComment], invoiceComments);
		const inheritedDeliveredDate = this.getInheritedDeliveredDate(receiveDetails.Asns, invoiceNumber as string);

		await this.setStateAsync({
			invoiceHeaderDetails: {
				invoiceId: receiveDetails.Invoice?.id,
				invoiceNumber: receiveDetails.Invoice?.invoiceNumber,
				invoiceDate: receiveDetails.Invoice?.invoiceDate,
				purchaseOrderNumber: receiveDetails.PurchaseOrder.sourceId,
				purchaseOrderStatus: receiveDetails.PurchaseOrder.status,
				purchaseOrderNotes: receiveDetails.PurchaseOrder.description,
				storeId: receiveDetails.PurchaseOrder.shipToLocation.locationId,
				storeName: receiveDetails.PurchaseOrder.shipToLocation.companyName,
				supplierName: receiveDetails.PurchaseOrder.vendorName,
				invoiceType: receiveDetails.PurchaseOrder.isEdi ? "EDI" : "Manual",
				receiveStatus: receiveDetails.MatchedReceive
					? receiveDetails.MatchedReceive.status
					: isAlreadyReceived
						? receiveStatus.receivedDirectly
						: receiveStatus.open,
				failureReason: receiveDetails.MatchedReceive?.failureReason,
				totalPriceInc: receiveDetails.Invoice?.totalCostInc,
				totalFreightInc: receiveDetails.Invoice?.freightCostInc,
				totalQty: receiveDetails.Invoice?.totalQuantity,
				asns: receiveDetails.Asns,
			},
			receive: receiveDetails.MatchedReceive,
			arrivals: receiveDetails.Arrivals,
			creditRequest: receiveDetails.CreditRequest,
			purchaseOrder: receiveDetails.PurchaseOrder,
			products: receiveDetails.Products,
			prices: receiveDetails.ProductPrices,
			customerOrders: receiveDetails.CustomerOrders.orders,
			inventory: receiveDetails.CustomerOrders.inventory,
			containsCustomerOrders: receiveDetails.CustomerOrders.orders.length > 0,
			invoiceDate: receiveDetails.Invoice?.invoiceDate,
			receivedDate: receiveDetails.MatchedReceive?.receivedDate
				? receiveDetails.MatchedReceive.receivedDate
				: inheritedDeliveredDate,
			isDeliveredDateDisabled: !receiveDetails.MatchedReceive?.receivedDate && !!inheritedDeliveredDate,
			isShowLoadingDialog: false,
			receiveFinalise: {
				...this.state.receiveFinalise,
				buttonName:
					!isFullyReceived(receiveDetails.MatchedReceive) && receiveDetails.CreditRequest
						? "Update Receive"
						: "Finalise",
				isDisabled: !isReceiveFinalisable,
			},
			preventReceiving: !invoiceNumberValidationResults.isValid,
			modalAlert: invoiceNumberValidationResults.isValid
				? modalClosed
				: {
						...modals.invalidEdiInvoiceNumber,
						paragraphs: [invoiceNumberValidationResults.reason],
						onPrimaryButtonClick: this.onCloseModalAlertAsync,
					},
			canPurchaseOrderBeReopened,
			locationId: receiveDetails.PurchaseOrder.shipToLocation.locationId,
			enableAssignIbLocation: isFeatureEnabledForLocationAndReceiveType(
				receiveDetails?.PurchaseOrder?.shipToLocation?.locationId ?? 0,
				inboundLocationAssignment,
				receiveDetails?.MatchedReceive?.receiveType ?? this.state.receiveType
			),
			enableProductLabelAutoPrint: isFeatureEnabledForLocationAndReceiveType(
				receiveDetails?.PurchaseOrder?.shipToLocation?.locationId ?? 0,
				productLabelAutoPrint,
				receiveDetails?.MatchedReceive?.receiveType ?? this.state.receiveType
			),
			enabledPriorityStock: enabledPriorityStock,
			comments: concatenatedComments,
		});

		const invoiceLineItems = await this.updateInvoiceLineItemTable();
		if (enabledPriorityStock) {
			await this.isPriorityStock(receiveDetails.PriorityStock, invoiceLineItems);
		}

		document.addEventListener("onScan", this.onScan);
		window.addEventListener("beforeunload", this.saveOnPageExit);
		await this.checkIfShouldBeCleared();
		await this.setScanEditVisiblity();
	}

	async componentWillUnmount() {
		document.removeEventListener("onScan", this.onScan);
		this.saveOnPageExit();
		window.removeEventListener("beforeunload", this.saveOnPageExit);
	}

	async componentDidUpdate(prevProps: ReceivingProps, prevState: ReceivingState) {
		const { inventory, isInventoryProcessed, invoiceLineItems } = this.state;

		// Process inventory when we have both inventory and invoice line items loaded
		if (!isInventoryProcessed && inventory && invoiceLineItems.length > 0) {
			// Check if either inventory or invoiceLineItems just changed
			if (inventory !== prevState.inventory || invoiceLineItems.length !== prevState.invoiceLineItems.length) {
				await this.setStateAsync({ isInventoryProcessed: true });
				await this.updateInvoiceLineItemInventory();
			}
		}
	}

	saveOnPageExit = async () => {
		const { receive } = this.state;
		if (receive) {
			await postReceiveAsync(receive);
		}
	};

	updateInvoiceLineItemTable = async () => {
		const { productGroups, receiveDetails } = this.getPageContext();
		const invoiceLineItems = receiveDetails?.Invoice?.lineItems ?? [];
		const PriorityStock = receiveDetails?.PriorityStock;
		const { products, prices, purchaseOrder, inventory, receive, enabledPriorityStock } = this.state;

		let updatedInvoiceLineItems = updateInvoiceLineItems(
			invoiceLineItems,
			products,
			productGroups,
			prices,
			purchaseOrder,
			inventory,
			receive
		);

		if (enabledPriorityStock) {
			await this.isPriorityStock(PriorityStock, updatedInvoiceLineItems);
			sortItemsByPriorityStockFlag(updatedInvoiceLineItems as any, this.state.flatPriorityStock);
		} else {
			sortItemsByModifiedDesc(updatedInvoiceLineItems);
		}
		const locationBays = mapLocationBaysFromReceiveLineItems(updatedInvoiceLineItems, this.state.inboundLocation);

		await this.setStateAsync({
			invoiceLineItems: updatedInvoiceLineItems,
			locationBays,
		});
		return updatedInvoiceLineItems;
	};

	matchInventory = (sku: string) => {
		return this.state.inventory && this.state.inventory.find((m: any) => m.sku === sku);
	};

	updateInvoiceLineItemInventory = async () => {
		const { invoiceLineItems } = this.state;
		let updatedInvoiceLineItems = [];
		for (let i = 0; i < invoiceLineItems.length; i++) {
			const invoiceLineItem = invoiceLineItems[i];
			const matchedInventory = this.matchInventory(invoiceLineItem.sku);
			const updatedInvoiceLineItem = {
				...invoiceLineItem,
				inventory: matchedInventory,
			};
			updatedInvoiceLineItems.push(updatedInvoiceLineItem);
		}
		await this.setStateAsync({
			invoiceLineItems: updatedInvoiceLineItems,
		});
	};

	setReceivedDate = (newDate: Date) => {
		this.setStateAsync({ receivedDate: newDate });
	};

	isValidReceivedDate = (dateValue?: string | Date | null): boolean => {
		if (!dateValue) return false;

		const parsedDate = dateValue instanceof Date ? dateValue : new Date(dateValue);

		return !isNaN(parsedDate.getTime()) && parsedDate.getFullYear() > 1;
	};

	/**
	 * Returns the delivered date from the ASN if an ASN has a dateDelivered
	 * AND a matching invoice number. Returns null otherwise.
	 */
	getInheritedDeliveredDate = (asns: any[], invoiceNumber?: string): string | null => {
		if (!asns || !invoiceNumber) return null;

		const matchingAsn = asns.find(
			(asn) => asn.shipment?.invoiceNumber === invoiceNumber && this.isValidReceivedDate(asn.shipment?.dateDelivered)
		);

		return matchingAsn?.shipment?.dateDelivered ?? null;
	};

	onSave = async () => {
		const isSaveSuccessful = await this.updateReceive();
		await this.setStateAsync({
			isSpeedDialOpen: false,
			snackBarAlert: isSaveSuccessful ? snackBarAlerts.success.savingReceive : snackBarAlerts.error.savingReceive,
		});
	};

	isDeliveryDateValid = async () => {
		let { receivedDate } = this.state;
		if (!this.isValidReceivedDate(receivedDate)) {
			await this.showDeliveredDateRequiredAlertAsync();
			return false;
		}
		return true;
	};

	updateReceive = async (postToReceive: boolean = true) => {
		let { invoiceLineItems, receivedDate, receiveId } = this.state;
		if (!(await this.isDeliveryDateValid())) return;
		const { receiveDetails } = this.getPageContext();
		let receive = createOrUpdateReceive(
			receiveDetails,
			invoiceLineItems,
			this.props.graphProfile,
			receivedDate,
			receiveId,
			this.state.receive?.notes || ""
		);
		receive.inventoryStatus = this.state.receive?.inventoryStatus;

		await this.setScanEditVisiblity();

		try {
			if (postToReceive) {
				await postReceiveAsync(receive);
			}
			await this.refreshReceiveAfterUpdateAsync(receive, receiveDetails);
			return true;
		} catch {
			await this.setStateAsync({
				receive,
				snackBarAlert: snackBarAlerts.error.savingReceive,
			});
			return false;
		}
	};

	onEditClick = async (invoiceLineItem: any) => {
		this.scrollToTop();
		await this.setStateAsync({
			currentScannedProduct: {
				qty: invoiceLineItem.received,
				productId: invoiceLineItem.sku,
			},
		});
	};

	onScan = (e: any) => {
		// Check if the model is open
		const { openArrivalsCheckinDialog, assignLocation } = this.state;

		if (assignLocation.isModalOpen) {
			void this.setStateAsync({
				assignLocation: { ...assignLocation, scannedLocation: e.data.BarcodeValue },
			});
			return;
		}
		if (openArrivalsCheckinDialog) {
			void this.setStateAsync({ scannedArrivalConsignmentNumber: e.data.BarcodeValue });
			return;
		}

		// Queue scans so they process sequentially, preventing race conditions
		// where rapid scans overwrite each other's state updates
		this.scanQueue = this.scanQueue
			.then(() => this.processScan(e.data.BarcodeValue))
			.catch((error: any) => {
				// Ensure the scan queue continues even if a scan fails
				console.error("Error while processing scan", error);
			});
	};

	private processScan = async (barcodeValue: string) => {
		this.scrollToTop();
		await this.setStateAsync({ isExpandedHeader: false });
		await this.onSaveItemClick(barcodeValue, null, "scan");
	};

	onHistoryClick = async (invoiceLineItem: any) => {
		await this.setStateAsync({ isHistoryVisible: true, skuForHistory: invoiceLineItem.sku });
	};

	onAllHistoryClick = async () => {
		await this.setStateAsync({ isHistoryVisible: true, skuForHistory: "" });
	};

	onCancelFinalise = async () => {
		await this.setStateAsync({
			receiveFinalise: { ...this.state.receiveFinalise, isModalOpen: false },
		});
	};

	handleSpeedDialClose = async () => {
		await this.setStateAsync({ isSpeedDialOpen: false });
	};

	handleSpeedDialOpen = async () => {
		await this.setStateAsync({ isSpeedDialOpen: true });
	};

	onDataChange = async (data: { qty: number | null; productId: string }) => {
		await this.setStateAsync({
			currentScannedProduct: {
				qty: data.qty,
				productId: data.productId,
			},
		});
	};

	showDeliveredDateRequiredAlertAsync = async () => {
		await this.setStateAsync({
			showAlert: true,
			alertMessage: "Delivered date must be set before receive can be updated.",
		});
	};

	onSaveItemClick = async (inputValue: string, qty: number | null, action: string = "edit") => {
		const { enableAssignIbLocation, inboundLocation, invoiceLineItems, products, receivedDate, receive } = this.state;
		const { putAwayLocations, receiveDetails } = this.getPageContext();

		if (enableAssignIbLocation && (isLocation(inputValue) || putAwayLocations.has(inputValue))) {
			// User is at a fulfilment centre, scanning an inbound location / put away location for the SKU
			if (
				isInboundLocation(inputValue, receiveDetails.PurchaseOrder.shipToLocation.locationId) ||
				putAwayLocations.has(inputValue)
			) {
				// Update location bays with new location
				const updatedLocationBays = updateLocationBays(inputValue, this.state.locationBays);
				await this.setStateAsync({
					locationBays: updatedLocationBays,
					inboundLocation: inputValue,
					currentScannedProduct: emptyCurrentScannedProduct,
				});
			} else {
				await this.setStateAsync({
					modal: {
						...modals.issueValidatingLocationBay,
						onPrimaryButtonClick: this.onCloseModal,
					},
				});
			}
			return;
		}

		// At this point we have scanned a SKU, increment the quantity
		let receiveLineItem = getScannedItemByProductId(invoiceLineItems, inputValue, products);

		const validationResults = await this.validateScanAllowed(
			inputValue,
			receiveLineItem,
			receivedDate,
			enableAssignIbLocation,
			inboundLocation,
			receive?.status
		);

		if (!validationResults.isValid) {
			await this.setStateAsync({
				showAlert: true,
				alertMessage: validationResults.reason,
			});

			return;
		}

		let newInvoiceLineItems = await this.updateInvoiceLineItemQtyAsync(inputValue, qty);
		if (enableAssignIbLocation && !receiveLineItem.inboundLocation) {
			// Set the location bay on the line item.
			// If the line item already has a bay assigned, the user will be prompted to confirm the change
			newInvoiceLineItems = editLocationBay(
				newInvoiceLineItems,
				receiveLineItem.inboundLocation,
				inboundLocation,
				receiveLineItem.sku
			);
		}

		await this.setStateAsync({
			currentScannedProduct: {
				qty: receiveLineItem.received,
				productId: inputValue,
			},
			invoiceLineItems: newInvoiceLineItems,
		});

		saveEventHistoryToList({
			date: new Date(),
			staffId: this.props.graphProfile.staffId,
			staffName: this.props.graphProfile.displayName,
			purchaseOrderNumber: this.state.purchaseOrder.sourceId,
			model: receiveLineItem.model,
			description: receiveLineItem.description,
			qty: receiveLineItem.received,
			action: action,
			invoiceNumber: this.state.receive?.invoiceNumber,
			sku: receiveLineItem.sku,
		});

		if (!receiveDetails.MatchedReceive) {
			await this.updateReceive(true);
		} else {
			// Existing Receive, increment the line item quantity
			try {
				if (
					enableAssignIbLocation &&
					receiveLineItem.inboundLocation &&
					receiveLineItem.inboundLocation !== inboundLocation
				) {
					// User will be required to confirm the location bay change, show a loading dialog so they don't start scanning other SKUs
					await this.setStateAsync({ isShowLoadingDialog: true });
				}

				// First update the local state to keep UI responsive
				await this.updateReceive(false);

				// Then make the API call without awaiting it
				const { staffId, displayName } = this.props.graphProfile;
				// Don't await - this API is designed to update the receive silently
				void postLineItemReceivedAsync({
					...createReceiveLineItemFromInvoiceLineItem(
						newInvoiceLineItems.find((rli) => rli.sku === receiveLineItem.sku),
						receiveDetails
					),
					receiveId: receiveDetails.MatchedReceive.id,
					modifiedBy: displayName,
					modifiedById: staffId,
					modifiedDate: new Date().toISOString(),
				}).finally(() => {
					this.setStateAsync({ isShowLoadingDialog: false });
				});
			} catch (error) {
				await this.setStateAsync({ isShowLoadingDialog: false });
			}
		}

		if (
			enableAssignIbLocation &&
			receiveLineItem.inboundLocation &&
			receiveLineItem.inboundLocation !== inboundLocation
		) {
			// User is at a fulfilment centre, scanning a SKU into a location bay that is different to the one
			// already assigned to this SKU. Show the "Assign Location" modal to confirm
			await this.setStateAsync({
				assignLocation: {
					...this.state.assignLocation,
					sku: receiveLineItem.sku,
					currentLocation: receiveLineItem.inboundLocation,
					scannedLocation: "",
					context: "scanned",
					isModalOpen: true,
				},
			});
		}
	};

	validateScanAllowed = async (
		scannedSku: string,
		receiveLineItem: any,
		receivedDate: string | Date | null,
		isFulfilmentCentre: boolean | undefined,
		scannedInboundLocation: string | null,
		receiveStatusValue: string | undefined
	) => {
		let validationResult = { isValid: true, reason: "" };
		if (receiveStatusValue && blockEdiScanStatusList.includes(receiveStatusValue)) {
			validationResult = {
				isValid: false,
				reason: `Cannot scan items for a receive with status ${statusToLabel(receiveStatusValue)}.`,
			};
		}
		if (!receivedDate) {
			validationResult = {
				isValid: false,
				reason: "Delivered date must be set before receive can be updated.",
			};
		} else if (isFulfilmentCentre && !scannedInboundLocation) {
			validationResult = {
				isValid: false,
				reason: "Before receiving items, you must assign a location.",
			};
		} else if (!receiveLineItem) {
			validationResult = {
				isValid: false,
				reason: `${scannedSku} does not belong to this invoice`,
			};
		}

		return validationResult;
	};

	onSwitchView = async () => {
		await this.setStateAsync({
			isHardwareView: !this.state.isHardwareView,
			isSpeedDialOpen: false,
		});
	};

	onViewCredits = async () => {
		await this.handleSpeedDialClose();
		const { receiveDetails } = this.getPageContext();
		const creditRequestId = receiveDetails.CreditRequest?.id;
		if (creditRequestId) {
			this.props.history.push(`/CreditRequest/Detail?id=${creditRequestId}`);
		}
	};

	toggleClearReceiveModal = async (isOpen: boolean) => {
		await this.setStateAsync({
			isClearReceiveModalOpen: isOpen,
		});
	};

	onClearReceive = async () => {
		const { receiveDetails } = this.getPageContext();
		const newSelectedInvoice = {
			...receiveDetails,
			MatchedReceive: { ...receiveDetails.MatchedReceive, status: receiveStatus.cancelled },
		};
		if (newSelectedInvoice.CreditRequest) {
			newSelectedInvoice.CreditRequest.lineItems = newSelectedInvoice.CreditRequest.lineItems.map((li) => {
				if (li.Status !== creditStatus.claimed) {
					return {
						...li,
						status: creditStatus.cancelled,
					};
				}
				return li;
			});
			await upsertCreditRequest(newSelectedInvoice.CreditRequest);
		}
		await this.setStateAsync({
			receive: { ...this.state.receive, status: receiveStatus.cancelled },
			receiveFinalise: { ...this.state.receiveFinalise, isDisabled: true },
			creditRequest: { ...newSelectedInvoice.CreditRequest },
		});
		await this.updatePageContextAsync({ receiveDetails: newSelectedInvoice });
		await this.updateReceive();
		await this.toggleClearReceiveModal(false);
	};

	handleCloseAlertAsync = async (_event?: any, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}
		await this.setStateAsync({ showAlert: false });
	};

	handleCloseHistoryAsync = async (_e?: any) => {
		await this.setStateAsync({ isHistoryVisible: false });
	};

	onRaiseCreditRequest = async () => {
		await this.updateReceive();

		const { receive } = this.state;
		this.props.history.push(
			`/CreditRequest?invoiceNumber=${receive.invoiceNumber}&purchaseOrderNumber=${receive.purchaseOrderNumber}`
		);
	};

	onCancelCreditRequest = async () => {
		await this.setStateAsync({
			receiveFinalise: { ...this.state.receiveFinalise, isCreditRequestModalOpen: false },
		});
	};

	updateInvoiceLineItemQtyAsync = async (productId: string, qty: number | null) => {
		const { invoiceLineItems, products } = this.state;
		let receiveLineItem = getScannedItemByProductId(invoiceLineItems, productId, products);
		if (!receiveLineItem) return;

		receiveLineItem.received = qty === null ? receiveLineItem.received + 1 : qty;
		receiveLineItem.remainder = receiveLineItem.invoiced - receiveLineItem.received;
		const newInvoiceLineItems = invoiceLineItems.map((item) => {
			if (item.sku === receiveLineItem.sku) {
				receiveLineItem.modifiedTimestamp = new Date();
				return receiveLineItem;
			}
			return item;
		});
		if (this.state.enabledPriorityStock) {
			sortItemsByPriorityStockFlag(newInvoiceLineItems, this.state.flatPriorityStock);
		} else {
			sortItemsByModifiedDesc(newInvoiceLineItems);
		}

		return newInvoiceLineItems;
	};

	handleCloseSnackbarAlertAsync = async () => {
		const { snackBarAlert } = this.state;
		await this.setStateAsync({ snackBarAlert: { ...snackBarAlert, isOpen: false } });
	};

	onCloseModalAlertAsync = async () => {
		await this.setStateAsync({ modalAlert: { ...modalClosed } });
	};

	onFinaliseSubmit = async (
		customerOrders: any[],
		hasLabels: boolean,
		skipAutoOrderAllocation: boolean,
		skipProductLabelPrinting: boolean
	) => {
		await this.setStateAsync({
			receiveFinalise: { ...this.state.receiveFinalise, isModalOpen: false },
			isShowLoadingDialog: true,
		});

		await this.updateReceive(false);

		const { selectedPrinterId, selectedLabelPrinterId, userLocation } = this.getPageContext();
		const { receive } = this.state;
		const { staffId, displayName } = this.props.graphProfile;

		receive.receiver = displayName;
		receive.receiverId = staffId;
		receive.status = "Incomplete";
		receive.invoiceDate = this.state.invoiceDate;
		receive.failureReason = null;
		receive.receiptAttemptCount = 0;
		await this.setStateAsync({ receive });

		try {
			await postSubmitReceiveAsync(
				receive,
				customerOrders,
				selectedPrinterId,
				selectedLabelPrinterId,
				userLocation,
				true,
				hasLabels,
				skipAutoOrderAllocation,
				skipProductLabelPrinting
			);
			let newInvoiceHeaderDetails = this.state.invoiceHeaderDetails;
			newInvoiceHeaderDetails.receiveStatus = receive.status;
			await this.setStateAsync({
				invoiceHeaderDetails: newInvoiceHeaderDetails,
				receiveFinalise: { ...this.state.receiveFinalise, isDisabled: true },
				snackBarAlert: snackBarAlerts.success.finalisedReceive,
				isSpeedDialOpen: false,
				isShowLoadingDialog: false,
			});
		} catch (e) {
			console.log(e);
			await this.setStateAsync({
				receiveFinalise: { ...this.state.receiveFinalise, isDisabled: false },
				modalAlert: {
					...modals.issueFinalisingReceive,
					paragraphs: [...modals.issueFinalisingReceive.paragraphs, e?.message],
				},
				isShowLoadingDialog: false,
			});
		}
	};

	onClickScrollToTop = () => {
		this.handleSpeedDialClose();
		this.scrollToTop();
	};

	scrollToTop = () => {
		window.scrollTo(0, 0);
	};

	setNotes = (notes: string) => {
		this.setStateAsync({
			receive: {
				...this.state.receive,
				notes: notes,
			},
		});
	};

	onCommentModalOpen = () => {
		this.setStateAsync({
			commentModal: {
				isOpen: true,
			},
		});
	};

	onCommentModalClose = () => {
		this.setStateAsync({
			commentModal: {
				isOpen: false,
			},
		});
	};

	// When this is moved to using hooks, use hook useComments instead
	onAddComment = async (commentText: string): Promise<void> => {
		if (!this.state.receive?.id) {
			throw new Error("No receive ID available");
		}

		try {
			const { staffId, displayName } = this.props.graphProfile;

			const commentRequest = {
				text: commentText,
				receiveId: this.state.receive.id,
				createdByUserId: staffId,
				createdByUserName: displayName,
			};
			const response: any = await postReceiveComment(this.state.receive.id, commentRequest);

			// Add the new comment to the comments array
			const newComment = response.data;
			const updatedComments = [newComment, ...this.state.comments];

			await this.setStateAsync({
				comments: updatedComments,
			});
		} catch (error) {
			console.error("Failed to add comment:", error);
			throw error;
		}
	};

	onClickReceiveFinalise = async () => {
		const { creditRequest } = this.state;

		await this.updateReceive();

		const validationResult = await validateReceiveAsync(
			this.state.invoiceLineItems,
			this.state.receivedDate,
			this.state.receive,
			[],
			this.state.purchaseOrder?.vendorId,
			true
		);
		await this.setStateAsync({ validationResult });

		if (validationResult.isValid) {
			const { receiveDetails } = this.getPageContext();

			// If receive finalise is disabled don't continue
			if (this.state.receiveFinalise.isDisabled) {
				return;
			}

			// Determine if credit request page will be required
			const isNowFullyReceived = isFullyReceived(this.state.receive);
			const hasCredit = Boolean(creditRequest || receiveDetails.CreditRequest);
			const isCreditRequestClaimed = Boolean(
				(creditRequest && creditRequest.status === creditStatus.claimed) ||
				(receiveDetails.CreditRequest && receiveDetails.CreditRequest.status === creditStatus.claimed)
			);
			const isCreditRequestPageRequired = Boolean(
				(!isNowFullyReceived && !isCreditRequestClaimed) ||
				(creditRequest && !isCreditRequestClaimed) ||
				(receiveDetails.CreditRequest && !isCreditRequestClaimed)
			);
			const hasAlert = this.state.showAlert;
			const hasLabels = this.state.receive.receiveLineItems.some((rli) => rli.hasLabel);
			await this.setStateAsync({ isCreditRequestPageRequired });

			// Soft allocate customer orders
			const allocatedCustomerOrders = reduceCustomerOrdersToFIFO(this.state.receive, this.state.customerOrders);
			await this.setStateAsync({ allocatedCustomerOrders });
			if (this.state.allocatedCustomerOrders.length > 0) {
				await this.setStateAsync({ isPrintVisible: true });
			}

			// Open finalise modal
			await this.setStateAsync({
				receiveFinalise: {
					...this.state.receiveFinalise,
					isModalOpen: !isCreditRequestPageRequired && !hasAlert, // If credit request page is required or there's an alert, open the alert instead of the finalise modal. Otherwise open the finalise modal.
					isCreditRequestModalOpen: isCreditRequestPageRequired,
					isFullyReceived: isNowFullyReceived,
					hasCredit,
					isCreditRequestClaimed,
					hasLabels,
				},
				isSpeedDialOpen: false,
			});
		} else {
			await this.setStateAsync({ showAlert: true, alertMessage: validationResult.reasons.toString() });
		}
	};

	getProcessedCreditRequestAsync = async () => {
		const { receiveDetails } = this.getPageContext();
		const creditRequest = await getCreditRequest(receiveDetails.CreditRequest.id);
		if (!creditRequest) {
			await this.setStateAsync({
				showAlert: true,
				alertMessage: "The credit request is currently processing and will be ready soon; please try again shortly.",
			});
		}
		return creditRequest;
	};

	checkIfShouldBeCleared = async () => {
		const { receiveDetails } = this.getPageContext();
		if (
			receiveDetails?.MatchedReceive &&
			isReceivedDirectInHost(receiveDetails.MatchedReceive.status, receiveDetails.Invoice?.status)
		) {
			await this.setStateAsync({
				showAlert: true,
				alertMessage:
					"Whoa there! Looks as though this receive has been processed directly in Shopkeeper. As this receive was In Progress it is now cleared.",
			});
			this.onClearReceive();
		}
	};

	setScanEditVisiblity = async () => {
		const { receiveStatus: status } = this.state.invoiceHeaderDetails;

		const isScanEditVisible =
			status &&
			status !== receiveStatus.completed &&
			status !== receiveStatus.cancelled &&
			status !== receiveStatus.receivedDirectly;

		await this.setStateAsync({ isScanEditVisible });
	};

	onRemoveExtraReceiveLineItemClick = async (invoiceLineItem: any) => {
		await this.setStateAsync({
			clearExtraReceive: {
				isModalOpen: true,
				modalMessage: `Are you sure you want to clear SKU ${invoiceLineItem.sku} from this invoice receive?`,
				sku: invoiceLineItem.sku,
			},
		});
	};

	onClearExtraReceive = async (sku: string) => {
		const { receive, invoiceLineItems } = this.state;
		receive.receiveLineItems.splice(
			receive.receiveLineItems.findIndex((r) => r.sku === sku),
			1
		);
		invoiceLineItems.splice(
			invoiceLineItems.findIndex((i) => i.sku === sku),
			1
		);

		await this.setStateAsync({
			clearExtraReceive: { isModalOpen: false, modalMessage: "", sku: "" },
			receive: receive,
			invoiceLineItems: invoiceLineItems,
		});
		await this.updateReceive();
	};

	onCloseModal = async () => {
		await this.setStateAsync({ modal: modalClosed });
	};

	returnToHome = () => {
		this.props.history.push("/");
	};

	onReopenPoClick = async () => {
		try {
			await this.setStateAsync({ isShowLoadingDialog: true });
			await postReopenPurchaseOrderAsync(this.state.purchaseOrder.sourceId);
			await this.setStateAsync({ isShowLoadingDialog: false });
			await this.setStateAsync({
				modal: {
					...modals.reopenPurchaseOrderSuccess,
					onPrimaryButtonClick: this.returnToHome,
				},
			});
		} catch (e) {
			await this.setStateAsync({ isShowLoadingDialog: false });
			await this.setStateAsync({
				modal: {
					...modals.reopenPurchaseOrderError,
					onPrimaryButtonClick: this.onCloseModal,
				},
			});
		}
	};

	isArrivalsFeatureEnabled = (receiveType?: string) => {
		const { userLocation, featureConfiguration } = this.getPageContext();
		const { arrivals } = featureConfiguration;

		return isFeatureEnabledForLocationAndReceiveType(userLocation, arrivals, receiveType ?? this.state.receiveType);
	};

	canCheckinShipment = () => {
		if (!this.isArrivalsFeatureEnabled()) return false;

		//Check #5254 for cases of when user can Check-in Shipment
		const { receiveDetails } = this.getPageContext();
		const { PurchaseOrder: po } = receiveDetails;

		return po.isEdi && (po.status === purchaseOrderStatus.released || po.status === purchaseOrderStatus.partReceived);
	};
	handleCheckinDialogOpenAsync = async () => {
		await this.setStateAsync({ openArrivalsCheckinDialog: true });
	};
	handleCheckinDialogCloseAsync = async (requiresConfirmation?: boolean) => {
		await this.setStateAsync({
			showArrivalsCheckingDialogCloseConfirmation: requiresConfirmation ?? false,
			isBlocking: requiresConfirmation ?? false,
		});
		if (!requiresConfirmation) this.handleCloseConfirmationAsync(true);
	};
	handleCloseConfirmationAsync = async (confirmed: boolean) => {
		this.setStateAsync({ showArrivalsCheckingDialogCloseConfirmation: false, isBlocking: false });
		if (confirmed) {
			await this.setStateAsync({
				openArrivalsCheckinDialog: false,
				scannedArrivalConsignmentNumber: null,
			});
			return true;
		}
		return false;
	};
	handleCompleteCheckinAsync = async (arrival: any) => {
		try {
			await this.handleCheckinDialogCloseAsync();
			const { receiveDetails } = this.getPageContext();
			await this.setStateAsync({ showSubmittingArrivalLoading: true });
			const { staffId, displayName } = this.props.graphProfile;
			arrival.createdByUserName = displayName;
			arrival.createdByUserId = staffId;
			this.setStateAsync({ receivedDate: arrival.dateArrived });
			const { invoiceLineItems, receivedDate, receiveId } = this.state;
			const currentStatus = receiveDetails.MatchedReceive?.status ?? receiveStatus.open;

			let receive = createOrUpdateReceive(
				receiveDetails,
				invoiceLineItems,
				this.props.graphProfile,
				receivedDate,
				receiveId,
				this.state.receive?.notes || ""
			);
			receive.arrival = arrival;

			// maintain status as arrived if just checking in another shipment. Or set status to arrived if current status is open
			if (currentStatus === receiveStatus.arrived || currentStatus === receiveStatus.open)
				receive.status = receiveStatus.arrived;

			const result = await postReceiveAsync(receive);

			await this.setStateAsync({
				receive,
				snackBarAlert: snackBarAlerts.success.savingArrival,
			});

			if (result) {
				if (currentStatus === receiveStatus.open) {
					if (receiveDetails.Invoice) {
						receiveDetails.Invoice.status = receiveStatus.arrived;
					}
					receive.status = receiveStatus.arrived;
				}
				receiveDetails.MatchedReceive = receive;
				await this.updatePageContextAsync({ receiveDetails });
				this.refreshReceiveAfterUpdateAsync(receive, receiveDetails);

				// Priority Stock notice
				const openPriorityStockDialog = this.state.flatPriorityStock.length > 0;
				//await this.setStateAsync({ purchaseOrderPriorityStock: poPriorityStock, flatPriorityStock: flatPriorityStock });
				await this.setStateAsync({ openPriorityStockDialog });
			}
		} catch (e) {
			await this.setStateAsync({ snackBarAlert: snackBarAlerts.error.savingArrival });
			console.log(e); // TODO: Proper error handling log to appInsights
		} finally {
			await this.setStateAsync({ showSubmittingArrivalLoading: false });
		}
	};

	refreshReceiveAfterUpdateAsync = async (receive: any, receiveDetails: any) => {
		let newInvoiceHeaderDetails = this.state.invoiceHeaderDetails;
		newInvoiceHeaderDetails.receiveStatus = receive.status;
		const inheritedDeliveredDate = this.getInheritedDeliveredDate(
			receiveDetails.Asns,
			newInvoiceHeaderDetails.invoiceNumber
		);
		const effectiveReceivedDate = receive?.receivedDate ?? inheritedDeliveredDate;

		// Reinstate original quantity
		receive.receiveLineItems.forEach((ri) => {
			ri.originalReceivedQuantity =
				receive.status === receiveStatus.inProgress || receive.status === receiveStatus.open
					? 0
					: receive.receiveLineItems.find((m) => m.sku === ri.sku)?.originalReceivedQuantity;
		});
		await this.setStateAsync({
			receive: receive,
			receivedDate: effectiveReceivedDate,
			isDeliveredDateDisabled: !receive?.receivedDate && !!inheritedDeliveredDate,
			invoiceHeaderDetails: newInvoiceHeaderDetails,
			receiveFinalise: {
				...this.state.receiveFinalise,
				isDisabled: !canBeFinalisedStatusList.includes(receive.status),
				buttonName: !isFullyReceived(receive) && receiveDetails.CreditRequest ? "Update Receive" : "Finalise",
			},
		});

		await this.updatePageContextAsync({ receiveDetails: { ...receiveDetails, MatchedReceive: receive } });

		await this.updateInvoiceLineItemTable();
	};
	handlePriorityStockDialogCloseAsync = async () => {
		await this.setStateAsync({ openPriorityStockDialog: false });
	};

	isPriorityStock = async (priorityStock: any[], invoiceLineItems: any[]) => {
		try {
			const { receiveDetails } = this.getPageContext();
			if (priorityStock && priorityStock.length > 0) {
				const groupedPriorityStock = groupByPriorityStockFlag(priorityStock, invoiceLineItems);
				const poPriorityStock = {
					priorityStock: groupedPriorityStock,
					poNumber: receiveDetails.Invoice?.purchaseOrderNumber,
				};
				await this.setStateAsync({ purchaseOrderPriorityStock: poPriorityStock, flatPriorityStock: priorityStock });
				return true;
			}
		} catch (ex) {
			// TODO: LOG to AppInsight when possible
		}
		return false;
	};

	onCloseModalAssignLocation = async () => {
		await this.setStateAsync({
			assignLocation: {
				...this.state.assignLocation,
				sku: "",
				currentLocation: "",
				context: "manual",
				scannedLocation: "",
				isModalOpen: false,
			},
		});
	};
	onCloseAlertModal = async () => {
		await this.setStateAsync({
			alertModal: {
				...this.state.alertModal,
				isOpen: false,
			},
		});
	};

	onLocationNameChange = async (currentLocation: string, sku: string) => {
		await this.setStateAsync({
			assignLocation: {
				...this.state.assignLocation,
				sku,
				currentLocation,
				scannedLocation: "",
				context: "manual",
				isModalOpen: true,
			},
		});
	};

	onLocationSubmit = async (previousLocation: string, updatedLocation: string, sku: string) => {
		const { invoiceLineItems, inboundLocation } = this.state;
		const { receiveDetails } = this.getPageContext();
		const newInvoiceLineItems = editLocationBay(invoiceLineItems, previousLocation, updatedLocation, sku);
		const locationBays = mapLocationBaysFromReceiveLineItems(newInvoiceLineItems, inboundLocation);

		await this.setStateAsync({
			assignLocation: {
				...this.state.assignLocation,
				sku: "",
				currentLocation: "",
				context: "manual",
				scannedLocation: "",
				isModalOpen: false,
			},
			invoiceLineItems: newInvoiceLineItems,
			locationBays,
		});

		if (!receiveDetails.MatchedReceive) return;

		if (sku) {
			// First update the local state to keep UI responsive
			await this.updateReceive(false);

			// Then make the API call without awaiting it
			const { staffId, displayName } = this.props.graphProfile;
			// Using void operator to explicitly ignore the Promise (suppresses missing await warning)
			void postLineItemReceivedAsync({
				...createReceiveLineItemFromInvoiceLineItem(
					newInvoiceLineItems.find((rli) => rli.sku === sku),
					receiveDetails
				),
				receiveId: receiveDetails.MatchedReceive.id,
				modifiedBy: displayName,
				modifiedById: staffId,
				modifiedDate: new Date().toISOString(),
			});
		} else {
			await this.updateReceive();
		}

		await this.setStateAsync({
			alertModal: {
				isOpen: true,
				title: "Successful Request",
				status: "success",
			},
		});
	};

	handleAccountChange = async (value: string) => {
		const receive = this.state.receive;
		await this.setStateAsync({ receive: { ...receive, inventoryStatus: value } });
	};

	mapInvoiceLineItemsByLocationBay = (locationName: string, lineItems: any[]) => {
		return lineItems.filter((rli) => {
			return rli.inboundLocation === locationName;
		});
	};

	render() {
		const { classes } = this.props;
		const {
			receiveDetails,
			featureConfiguration: { commercialAccountSelection },
			commercialAccounts: accounts,
			userLocation,
		} = this.getPageContext();
		const isReceiveEditable = isEditable(this.state.receive) && !this.state.preventReceiving;
		const isArrivalsFeatureEnabled = this.isArrivalsFeatureEnabled(receiveDetails?.MatchedReceive?.receiveType);

		const enableCommercialAccountSelection = isFeatureEnabledForLocationAndReceiveType(
			receiveDetails?.PurchaseOrder?.shipToLocation?.locationId,
			commercialAccountSelection,
			receiveDetails?.MatchedReceive?.receiveType ?? this.state.receiveType
		);
		const invoiceLineItems = this.state.invoiceLineItems;
		const latestStatusHistory =
			this.state.receive?.statusHistory?.length > 0 ? this.state.receive?.statusHistory?.at(-1) : null;
		const currentReceiveStatus = this.state.receive?.status || latestStatusHistory?.status;
		return (
			<div>
				<SnackbarAlert
					open={this.state.snackBarAlert.isOpen}
					message={this.state.snackBarAlert.message}
					severity={this.state.snackBarAlert.severity}
					onClose={this.handleCloseSnackbarAlertAsync}
				/>
				<Backdrop open={this.state.isSpeedDialOpen || !isReceiveEditable} className={classes.backDrop} />
				<Grid container direction="column" size="grow" className={classes.marginBottom}>
					<InvoiceHeaderDetails
						{...this.state.invoiceHeaderDetails}
						isExpandedHeader={this.state.isExpandedHeader}
						onExpandedButtonClick={(isExpended) => {
							this.setState({ isExpandedHeader: isExpended });
						}}
						receivedDate={this.state.receivedDate}
						setReceivedDate={this.setReceivedDate}
						isDeliveredDateDisabled={this.state.isDeliveredDateDisabled}
						latestStatusHistory={latestStatusHistory}
						receiveStatus={currentReceiveStatus}
						setNotes={this.setNotes}
						notes={this.state.receive?.notes}
						comments={this.state.comments}
						onCommentModalOpen={this.onCommentModalOpen}
						receiveId={this.state.receive?.id}
					/>
					{enableCommercialAccountSelection &&
						accounts?.length > 0 &&
						userLocation === parseInt(receiveDetails?.PurchaseOrder?.shipToLocation?.locationId) && (
							<CommercialSelect
								id="Commerical Account"
								menuItems={accounts}
								onChange={this.handleAccountChange}
								currentValue={this.state.receive?.inventoryStatus}
							/>
						)}
					{this.state.isScanEditVisible && (
						<ScanEditWithSaveButton
							productId={this.state.currentScannedProduct.productId}
							productQty={this.state.currentScannedProduct.qty}
							onDataChange={this.onDataChange}
							onSaveItemClick={this.onSaveItemClick}
							enableAssignIbLocation={this.state.enableAssignIbLocation}
						/>
					)}

					{(!this.state.enableAssignIbLocation || this.state.locationBays.length === 0) && (
						<MemorizedInvoiceLineItemTable
							onEditClick={this.onEditClick}
							onHistoryClick={this.onHistoryClick}
							onRemoveClick={this.onRemoveExtraReceiveLineItemClick}
							isDisableHistoryButton={!this.state.receive}
							invoiceLineItems={invoiceLineItems}
							creditRequest={this.state.creditRequest}
							isHardwareView={this.state.isHardwareView}
							isEditable={!this.state.receiveFinalise.isDisabled}
							priorityStock={this.state.flatPriorityStock}
							isArrivalsFeatureEnabled={isArrivalsFeatureEnabled}
							isPriorityStockEnabled={this.state.enabledPriorityStock}
							isLocationBayEditable={false}
							onLocationNameChange={() => {}}
						/>
					)}

					{this.state.enableAssignIbLocation && this.state.locationBays.length > 0 && (
						<>
							<CurrentLocationBayAlert currentLocation={this.state.inboundLocation} />

							{this.state.locationBays.map((locationBay, idx) => {
								const lineItems = this.mapInvoiceLineItemsByLocationBay(locationBay, invoiceLineItems);

								return (
									<React.Fragment key={idx}>
										<LocationBay
											key={idx}
											locationName={locationBay}
											onLocationNameChange={this.onLocationNameChange}
											hasLineItems={lineItems.length > 0}
										>
											<MemorizedInvoiceLineItemTable
												onEditClick={this.onEditClick}
												onHistoryClick={this.onHistoryClick}
												onRemoveClick={this.onRemoveExtraReceiveLineItemClick}
												isDisableHistoryButton={!this.state.receive}
												invoiceLineItems={lineItems}
												creditRequest={this.state.creditRequest}
												isHardwareView={this.state.isHardwareView}
												isEditable={!this.state.receiveFinalise.isDisabled}
												priorityStock={this.state.flatPriorityStock}
												isArrivalsFeatureEnabled={isArrivalsFeatureEnabled}
												isPriorityStockEnabled={this.state.enabledPriorityStock}
												isLocationBayEditable={!this.state.receiveFinalise.isDisabled}
												onLocationNameChange={this.onLocationNameChange}
											/>
										</LocationBay>
									</React.Fragment>
								);
							})}
						</>
					)}
				</Grid>
				{this.state.assignLocation.isModalOpen && (
					<ModalAssignLocation
						isOpen={this.state.assignLocation.isModalOpen}
						onSubmit={this.onLocationSubmit}
						onCancel={this.onCloseModalAssignLocation}
						poLocation={receiveDetails?.PurchaseOrder?.shipToLocation?.locationId ?? "0"}
						scannedInboundLocation={this.state.assignLocation.scannedLocation}
						currentLocation={this.state.assignLocation.currentLocation}
						sku={this.state.assignLocation.sku}
						context={this.state.assignLocation.context}
					/>
				)}

				{this.state.alertModal.isOpen && (
					<AlertModal
						isOpen={this.state.alertModal.isOpen}
						title={this.state.alertModal.title}
						status={this.state.alertModal.status}
						onClose={this.onCloseAlertModal}
					/>
				)}

				{this.state.receiveFinalise.isModalOpen && (
					<ModalReceiveFinalise
						isOpen={this.state.receiveFinalise.isModalOpen}
						hasExistingCredit={this.state.receiveFinalise.hasCredit}
						isCreditRequestClaimed={this.state.receiveFinalise.isCreditRequestClaimed}
						skipAllocation={false}
						onFinaliseSubmit={this.onFinaliseSubmit}
						onCancelFinalise={this.onCancelFinalise}
						locationId={this.state.locationId}
						receive={this.state.receive}
						hasLabels={this.state.enableProductLabelAutoPrint && this.state.receiveFinalise.hasLabels}
					/>
				)}
				<ModalCreditRequestFinalise
					isFullyReceived={this.state.receiveFinalise.isFullyReceived}
					hasExistingCredit={this.state.receiveFinalise.hasCredit}
					onCancelCreditRequest={this.onCancelCreditRequest}
					onRaiseCreditRequest={this.onRaiseCreditRequest}
					isOpen={this.state.receiveFinalise.isCreditRequestModalOpen}
				/>

				<ModalWithActionButton
					title="Warning"
					alertType={alertTypeEnum.WARNING as ModalAlertType}
					primaryButtonName="Ok"
					onPrimaryButtonClick={() => this.handleCloseAlertAsync()}
					isOpen={this.state.showAlert}
					message={this.state.alertMessage}
				/>
				<ModalHistory
					title="Receive History"
					alertType={alertTypeEnum.INFO}
					primaryButtonName="Ok"
					onPrimaryButtonClick={() => this.handleCloseHistoryAsync()}
					onClose={() => this.handleCloseHistoryAsync()}
					isOpen={this.state.isHistoryVisible}
					children={
						<ReceiveHistory
							statusHistoryList={this.state.receive ? (this.state.receive.statusHistory ?? []) : []}
							invoiceNumber={this.state.receive ? this.state.receive.invoiceNumber : ""}
							sku={this.state.skuForHistory}
							arrivals={this.state.arrivals}
						/>
					}
					size={modalSize.FULLSCREEN}
				/>
				<ModalWithActionButton
					title="Clear Receive"
					alertType={alertTypeEnum.WARNING as ModalAlertType}
					primaryButtonName="Yes"
					secondaryButtonName="No"
					onPrimaryButtonClick={() => this.onClearReceive()}
					onSecondaryButtonClick={() => this.toggleClearReceiveModal(false)}
					isOpen={this.state.isClearReceiveModalOpen}
					message={`Are you sure you want to clear this receive? ${
						this.state.receive?.status === receiveStatus.pendingFinalise
							? "This is a pending finalise receive, you must check that stock is received in Shopkeeper if it was intended to be!"
							: ""
					}`}
				/>
				<ModalWithActionButton
					title="Clear Incorrect SKU"
					alertType={alertTypeEnum.WARNING as ModalAlertType}
					primaryButtonName="Yes"
					secondaryButtonName="No"
					onPrimaryButtonClick={() => this.onClearExtraReceive(this.state.clearExtraReceive.sku)}
					onSecondaryButtonClick={() =>
						this.setState({ clearExtraReceive: { isModalOpen: false, modalMessage: "", sku: "" } })
					}
					isOpen={this.state.clearExtraReceive.isModalOpen}
					message={this.state.clearExtraReceive.modalMessage}
				/>
				<CommentModal
					isOpen={this.state.commentModal.isOpen}
					isDisabled={this.state.receiveFinalise.isDisabled}
					onClose={this.onCommentModalClose}
					comments={this.state.comments}
					onAddComment={this.onAddComment}
				/>
				<Modal {...this.state.modalAlert} onPrimaryButtonClick={this.onCloseModalAlertAsync} />
				<Modal
					{...this.state.modal}
					onPrimaryButtonClick={this.onCloseModal}
					onSecondaryButtonClick={this.onCloseModal}
				/>
				<SpeedDialMenu
					isOpen={this.state.isSpeedDialOpen}
					onClose={this.handleSpeedDialClose}
					onOpen={this.handleSpeedDialOpen}
					actions={[
						{
							title: speedDialAction.viewCredits,
							onClick: this.onViewCredits,
							isDisplay: this.state.creditRequest && this.state.receive,
						},
						{ title: speedDialAction.save, onClick: this.onSave, isDisplay: isReceiveEditable },
						{
							title: speedDialAction.finalise,
							onClick: this.onClickReceiveFinalise,
							isDisplay: !this.state.receiveFinalise.isDisabled && isReceiveEditable,
						},
						{ title: speedDialAction.history, onClick: this.onAllHistoryClick, isDisplay: this.state.receive },
						{
							title: this.state.isHardwareView ? speedDialAction.hardwareView : speedDialAction.softwareView,
							onClick: this.onSwitchView,
							isDisplay: true,
						},
						{
							title: speedDialAction.clearReceive,
							onClick: () => this.toggleClearReceiveModal(true),
							isDisplay: this.state.receive?.status && canBeClearedStatusList.includes(this.state.receive?.status),
						},
						{
							title: speedDialAction.checkinShipment,
							onClick: async () => await this.handleCheckinDialogOpenAsync(),
							isDisplay: this.state.canCheckinShipment,
						},
						{
							title: speedDialAction.scrollToTop,
							onClick: () => this.onClickScrollToTop(),
							isDisplay: true,
						},
						{
							title: speedDialAction.reopenPurchaseOrder,
							onClick: this.onReopenPoClick,
							isDisplay: this.state.canPurchaseOrderBeReopened && isReceiveEditable,
						},
						{
							title: speedDialAction.comments,
							onClick: this.onCommentModalOpen,
							isDisplay: this.state.receive,
						},
					]}
				/>
				<ArrivalsCheckinDialog
					purchaseOrders={this.state.poToCheckin}
					isOpen={this.state.openArrivalsCheckinDialog}
					onClose={this.handleCheckinDialogCloseAsync}
					onCompleteCheckin={this.handleCompleteCheckinAsync}
					scannedConsignmentNumber={this.state.scannedArrivalConsignmentNumber}
					isBlocking={this.state.isBlocking}
				/>
				<PriorityStockDialog
					isOpen={this.state.openPriorityStockDialog}
					onClose={this.handlePriorityStockDialogCloseAsync}
					purchaseOrderPriorityStock={this.state.purchaseOrderPriorityStock}
				/>
				<LoadingDialog message={"Loading..."} isOpen={this.state.isShowLoadingDialog} />

				{this.state.showSubmittingArrivalLoading && (
					<LoadingDialog message="Submitting arrival..." isOpen={this.state.showSubmittingArrivalLoading} />
				)}
				{this.state.showArrivalsCheckingDialogCloseConfirmation && (
					<ModalWithActionButton
						title="Warning"
						alertType={"warning" as ModalAlertType}
						primaryButtonName="Yes"
						secondaryButtonName="No"
						onPrimaryButtonClick={() => this.handleCloseConfirmationAsync(true)}
						onSecondaryButtonClick={() => this.handleCloseConfirmationAsync(false)}
						isOpen={this.state.showArrivalsCheckingDialogCloseConfirmation}
						message="Are you sure you want to exit?"
					/>
				)}
			</div>
		);
	}
}

export default withStyles(styles)(Receiving);
